import { Link } from 'react-router-dom';
import { useDocumentMeta } from '../lib/use-document-meta.js';
import { metaForPath } from '../lib/route-meta.js';
import './WhoWeAre.css';

// Standalone "About" page, linked from the homepage footer.
export default function WhoWeAre() {
  useDocumentMeta(metaForPath('/who-we-are'));

  return (
    <div className="ww-page">
      <header className="ww-header">
        <Link to="/" className="ww-brand">Margin</Link>
        <Link to="/#offer" className="ww-cta">Start a conversation</Link>
      </header>

      <main className="ww-main">
        <div className="ww-kicker">About</div>
        <h1 className="ww-h1">Who you're working with</h1>
        <div className="ww-body">
          <p>I'm Jason Lyons. I build operating systems for organizations that have been handed something nobody can describe, and I've been doing a version of that for twenty seven years.</p>
          <p>I spent 27 years carrying the same load in live theater, on multi-million-dollar productions where opening night was a fixed date, the budget never grew, and crews from multiple unions had to deliver as one. Those shows were built to run night after night, with or without me in the room. I owned my business the whole way, so I understand the responsibility you face.</p>
          <p>I work alone. There's no bench behind me, no junior team learning on your project, no account manager between us. You get me, and then at some point you don't, because that's the design. On the Bakowski Bridge of Lights I certified thirty Title I high school students to run the system independently. It has run nightly for two years since. I haven't touched it.</p>
        </div>
        <Link to="/#offer" className="ww-bottom-cta">Start a conversation</Link>
      </main>
    </div>
  );
}
